var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridType2Solid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C28",
    fillRule: "evenodd",
    d: "M2.798.167A2.132 2.132 0 0 0 .666 2.299v1.55c0 1.178.954 2.132 2.132 2.132h3.1A2.132 2.132 0 0 0 8.03 3.849V2.3A2.132 2.132 0 0 0 5.9.167H2.798Zm0 6.977A2.132 2.132 0 0 0 .666 9.276v5.426c0 1.177.954 2.132 2.132 2.132h3.1a2.132 2.132 0 0 0 2.132-2.132V9.276A2.132 2.132 0 0 0 5.9 7.144H2.798Zm7.17 6.008c0-1.178.955-2.132 2.132-2.132h3.1c1.178 0 2.133.954 2.133 2.132v1.55a2.132 2.132 0 0 1-2.132 2.132h-3.1a2.132 2.132 0 0 1-2.133-2.132v-1.55ZM12.1.167a2.132 2.132 0 0 0-2.132 2.132v5.426c0 1.177.955 2.132 2.132 2.132h3.1a2.132 2.132 0 0 0 2.133-2.132V2.3A2.132 2.132 0 0 0 15.2.167h-3.1Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridType2Solid);
export default __webpack_public_path__ + "static/media/grid-type-2-solid.ac3fbfe938ae46dc8382cd55a0fd8e44.svg";
export { ForwardRef as ReactComponent };